<template>
  <div class="Breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">{{$t('otherPage.p1')}}</el-breadcrumb-item>
      <el-breadcrumb-item @click.native="toUrl(firstNav.url)">{{firstNav.title}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="$route.path.indexOf(item.name) != -1" @click.native="toUrl(item.url)" v-for="item in secondNav" :key="item.url">{{item.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: "Breadcrumb",
    data(){
      return{
        // 一级Nav
        firstNav:{},
        // 二级Nav
        secondNav :[]
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        if(val =='zh'){
          this.$store.getters.menu.forEach((val) => {
            if (this.$route.path.indexOf(val.name) != -1) {
              this.$set(this,"firstNav",val)
              this.secondNav = val.child
            }
          })
        }else{
          this.$store.getters.menuEn.forEach((val) => {
            if (this.$route.path.indexOf(val.name) != -1) {
              this.$set(this,"firstNav",val)
              this.secondNav = val.child
            }
          })
        }
      }
    },
    created() {
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
            this.secondNav = val.child
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
            this.secondNav = val.child
          }
        })
      }
    },
    methods:{
      // 跳转导航
      toUrl(path){
        if (this.$router.currentRoute.path !== path) {
          this.$router.push(path);
        }
      }
    },
  }
</script>

<style scoped lang="less">
  .Breadcrumb {
    width: 1380px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 40px;
    padding-bottom: 60px;
  }
  .el-breadcrumb {
    font-size: 20px;
  }
  .el-breadcrumb__item{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/common/Breadcrumb.vue